import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-9ee5f7c8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "collection-item-detail-wrapper"
};
const _hoisted_2 = {
  class: "block"
};
const _hoisted_3 = {
  class: "wrapper"
};
const _hoisted_4 = {
  class: "image-container"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "collection-container"
};
const _hoisted_7 = {
  class: "font-subtitle1 title"
};
const _hoisted_8 = ["innerHTML"];

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-button1 text"
}, "Read More", -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "chevron"
}, null, -1));

const _hoisted_11 = [_hoisted_9, _hoisted_10];
const _hoisted_12 = {
  class: "block"
};
const _hoisted_13 = {
  class: "wrapper"
};
const _hoisted_14 = {
  class: "font-h5 name"
};
const _hoisted_15 = {
  class: "row"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption1 title"
}, "Owner", -1));

const _hoisted_17 = {
  class: "row"
};
const _hoisted_18 = {
  class: "font-subtitle1 value"
};
const _hoisted_19 = {
  class: "row"
};
const _hoisted_20 = {
  class: "title-wrapper"
};

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption1 title"
}, "Base Value", -1));

const _hoisted_22 = {
  class: "column"
};
const _hoisted_23 = {
  class: "font-h5 price"
};
const _hoisted_24 = {
  class: "font-caption1 unit"
};
const _hoisted_25 = {
  class: "row"
};
const _hoisted_26 = {
  class: "title-wrapper"
};

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption1 title"
}, "Reward", -1));

const _hoisted_28 = {
  class: "row"
};
const _hoisted_29 = {
  class: "font-h5 price"
};

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption1 unit"
}, "BCNT", -1));

const _hoisted_31 = {
  class: "row"
};
const _hoisted_32 = {
  class: "title-wrapper"
};

const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption1 title"
}, "Bonus", -1));

const _hoisted_34 = {
  class: "row"
};
const _hoisted_35 = {
  class: "font-h5 price"
};

const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption1 unit"
}, "BCNT", -1));

const _hoisted_37 = {
  class: "row"
};
const _hoisted_38 = {
  class: "row"
};

const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption1 title"
}, "Claim Date", -1));

const _hoisted_40 = {
  class: "font-subtitle1 value"
};
const _hoisted_41 = {
  class: "row"
};

const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption1 title"
}, "Contract Address", -1));

const _hoisted_43 = {
  class: "font-subtitle1 value"
};
const _hoisted_44 = {
  class: "row"
};

const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption1 title"
}, "Token ID", -1));

const _hoisted_46 = {
  class: "font-subtitle1 value"
};
const _hoisted_47 = {
  class: "row"
};

const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption1 title"
}, "Blockchain", -1));

const _hoisted_49 = {
  class: "font-subtitle1 value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tooltips_card = _resolveComponent("tooltips-card");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: $data.opened ? $data.detail.metadata?.image : $setup.Blindbox,
    alt: "image"
  }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    class: "profile-picture",
    style: _normalizeStyle(`background-image: url(${$data.info.profile})`)
  }, null, 4), _createElementVNode("div", _hoisted_7, _toDisplayString($data.info.title), 1)]), $data.info.desc ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["description-container", {
      expand: $data.isExpand
    }])
  }, [_createElementVNode("p", {
    class: "font-body3 desc",
    innerHTML: $data.info.desc
  }, null, 8, _hoisted_8), $data.info.desc.length > 300 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "read-more-wrapper",
    onClick: _cache[0] || (_cache[0] = $event => $data.isExpand = !$data.isExpand)
  }, _hoisted_11)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("h5", _hoisted_14, _toDisplayString(`${$data.detail.metadata?.name || "-"}`), 1), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, _toDisplayString($setup.briefAddress($data.detail.ownerOf)), 1)])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createVNode(_component_tooltips_card, {
    desc: 'base value'
  })]), _createElementVNode("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, _toDisplayString($data.baseValue), 1), _createElementVNode("span", _hoisted_24, _toDisplayString($data.baseValueToken), 1)])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_hoisted_27, _createVNode(_component_tooltips_card, {
    desc: 'reward'
  })]), _createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, _toDisplayString($data.reward), 1), _hoisted_30])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_hoisted_33, _createVNode(_component_tooltips_card, {
    desc: 'bonus'
  })]), _createElementVNode("div", _hoisted_34, [_createElementVNode("span", _hoisted_35, _toDisplayString($data.bonus), 1), _hoisted_36])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("span", _hoisted_40, _toDisplayString($data.claimDate), 1)]), _createElementVNode("div", _hoisted_41, [_hoisted_42, _createElementVNode("span", _hoisted_43, _toDisplayString($setup.briefAddress($data.detail.tokenAddress)), 1)]), _createElementVNode("div", _hoisted_44, [_hoisted_45, _createElementVNode("span", _hoisted_46, _toDisplayString($setup.briefAddress($data.detail.tokenId)), 1)]), _createElementVNode("div", _hoisted_47, [_hoisted_48, _createElementVNode("span", _hoisted_49, _toDisplayString($data.chain), 1)])])])])]);
}